import { render, staticRenderFns } from "./FabricDetailTableRow.vue?vue&type=template&id=f9028420&scoped=true&"
import script from "./FabricDetailTableRow.vue?vue&type=script&lang=js&"
export * from "./FabricDetailTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9028420",
  null
  
)

export default component.exports